import React from 'react';
import "./Subscription_Plan_card.css";

function Subscription_Plan_card({ title, price, duration, features, isActive = false, onSelect }) {
  return (
    <section 
      className={`Subscription_Plan_card ${isActive ? 'active' : ''}`} 
      onClick={onSelect}
    >
      <div className="heading_text">
        <h3>{title}</h3>
      </div>

      <div className="info_holder">
        <div className='price_holder'>
          <p>PLAN NAME</p>
          <span class="final-price">₹. {price} {price != 0 && (<sub>+(18% GST)</sub>)}</span>
        </div>

        <div className='duration_holder flex_box'>
          <h3>Duration:</h3>
          <p>
            {duration} <br /> <sub>(1 hour daily)</sub>
          </p>
        </div>

        <div className='duration_holder'>
          <h3>Features:</h3>
            {features.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
        </div>
      </div>
    </section>
  );
}

export default Subscription_Plan_card
